import { Controller } from '@hotwired/stimulus'

// POSTs the value of a webhook input to a test endpoint and displays the result.
//
// Usage:
//   data-controller="slack-webhook-test"
//   data-slack-webhook-test-url-value="/onboarding/test_slack"
//
//   <input data-slack-webhook-test-target="input">
//   <button data-action="slack-webhook-test#test">Tester</button>
//   <span data-slack-webhook-test-target="result"></span>
export default class extends Controller {
  static targets = ['input', 'button', 'result']
  static values = { url: String }

  async test() {
    const webhook = this.inputTarget.value.trim()
    if (!webhook) {
      this.#setResult('Entre l\'URL du webhook d\'abord', 'error')
      return
    }

    this.#disableButton()
    this.#setResult('Envoi...', 'pending')

    try {
      const response = await fetch(this.urlValue, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-CSRF-Token': this.#csrfToken()
        },
        body: `slack_webhook_url=${encodeURIComponent(webhook)}`
      })
      const data = await response.json()

      if (data.ok) {
        this.#setResult('\u2713 Message envoye sur Slack !', 'ok')
      } else {
        this.#setResult(`\u2717 ${data.error || 'Echec'}`, 'error')
      }
    } catch (error) {
      this.#setResult(`\u2717 ${error.message}`, 'error')
    } finally {
      this.#enableButton()
    }
  }

  #setResult(text, kind) {
    if (!this.hasResultTarget) return

    this.resultTarget.textContent = text
    this.resultTarget.dataset.kind = kind
  }

  #disableButton() {
    if (this.hasButtonTarget) this.buttonTarget.disabled = true
  }

  #enableButton() {
    if (this.hasButtonTarget) this.buttonTarget.disabled = false
  }

  #csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content
  }
}
